import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Box from '@mui/material/Box';

type HeaderCellProps = {
  id: string;
  label: string;
  pad?: boolean;
};

export type TableHeaderProps = {
  orderBy: string;
  sortOrder?: 'asc' | 'desc';
  onRequestSort: (field: string) => void;
};

const ClientTableHeader = ({
  orderBy,
  sortOrder = 'asc',
  onRequestSort,
}: TableHeaderProps) => {
  const HeaderCell = ({ id, label }: HeaderCellProps) => (
    <TableCell
      key={id}
      align="left"
      size="small"
      padding="normal"
      sortDirection={id === orderBy ? sortOrder : false}
    >
      <TableSortLabel
        active={id === orderBy}
        direction={sortOrder}
        onClick={() => onRequestSort(id)}
      >
        {label}
        {id === orderBy ? (
          <Box
            component="span"
            sx={{
              border: 0,
              clip: 'rect(0,0,0,0)',
              height: 1,
              margin: -1,
              overflow: 'hidden',
              padding: 0,
              position: 'absolute',
              top: 20,
              width: 1,
            }}
          >
            {sortOrder === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </Box>
        ) : null}
      </TableSortLabel>
    </TableCell>
  );

  return (
    <TableHead>
      <TableRow>
        <HeaderCell id="name" label="Name" />
        <HeaderCell id="phone" label="Phone" />
        <HeaderCell id="type" label="Type" />
        <HeaderCell id="sender" label="Sender" />
        <HeaderCell id="senderPhone" label="Sender Phone" />
      </TableRow>
    </TableHead>
  );
};

export default ClientTableHeader;
